import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Typography, Collapse } from 'antd'

import { gql } from '@apollo/client'

import ReactMarkdown from 'react-markdown'
import NextLink from 'next/link'
import {
  FAQ_DESCRIPTION_LIMIT,
  SOFTWARE_FAQ_DESCRIPTION_LIMIT,
} from 'shared/constants'

const { Panel } = Collapse
const { Title } = Typography

const ArticleLink = ({ slug, text }) => (
  <NextLink
    href="/article/[slug]"
    as={`/article/${slug}`}
    className="ant-anchor-link-title ant-anchor-link-title-active"
  >
    {text}
  </NextLink>
)

ArticleLink.propTypes = {
  slug: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

const customTitle = (title, slug) => {
  return (
    <Title level={4} style={{ margin: '0px' }}>
      <ArticleLink slug={slug} text={title} />
    </Title>
  )
}

const HeaderTitle = () => (
  <Title level={3} style={{ margin: '0px' }}>
    Frequently Asked Questions or FAQs
  </Title>
)

const articleCollaps = (article, index, type = null) => {
  const {
    title,
    slug,
    short_description: shortDescription,
    description,
  } = article.attributes

  const wordLimit =
    type === 'softwares'
      ? SOFTWARE_FAQ_DESCRIPTION_LIMIT
      : FAQ_DESCRIPTION_LIMIT

  return (
    <Panel
      header={customTitle(title, slug)}
      className="pannelCon"
      key={index}
      showArrow={false}
      disabled
    >
      <ReactMarkdown>
        {(shortDescription || description).split(' ', wordLimit).join(' ')}
      </ReactMarkdown>
      <div style={{ width: '100%', textAlign: 'right' }}>
        <ArticleLink slug={slug} text=".. Read More" />
      </div>
    </Panel>
  )
}

const CollapseHeader = () => {
  return (
    <Panel
      header={<HeaderTitle />}
      className="pannelCon"
      key="header"
      showArrow={false}
      disabled
    />
  )
}
export default function ArticleList({ articles, type = null }) {
  if (articles.length === 0) {
    return null
  }

  return (
    <Row className="page-wrapper">
      <Col
        span={24}
        style={{
          fontWeight: 'normal',
          fontSize: '16px',
          lineHeight: '22px',
        }}
      >
        <Collapse
          bordered={false}
          defaultActiveKey={articles.map((_, index) => index)}
        >
          <CollapseHeader />
          {articles.map((article, index) => {
            return articleCollaps(article, index, type)
          })}
        </Collapse>
      </Col>
    </Row>
  )
}

ArticleList.fragments = {
  articles: gql`
    fragment Articles on Article {
      slug
      title
      short_description
      description
    }
  `,
}
